export var HotspotStyle;
(function (HotspotStyle) {
    /** Used by Linear Flow step */
    HotspotStyle["HotspotWithText"] = "teach-hotspot";
    /** Used by Hotspot Map hotspot */
    HotspotStyle["HotspotIcon"] = "student-hotspot-non-sequenced";
    HotspotStyle["HotspotIconVisited"] = "student-hotspot-non-sequenced--visited";
    HotspotStyle["HotspotPolygonal"] = "hotspot-non-sequenced-polygonal";
    HotspotStyle["HotspotPolygonalInvisible"] = "hotspot-non-sequenced-polygonal-invisible";
    HotspotStyle["HotspotPolygonalManager"] = "hotspot-non-sequenced-polygonal--manager";
    HotspotStyle["HotspotPolygonalManagerInvisible"] = "hotspot-non-sequenced-polygonal--manager-invisible";
    HotspotStyle["HotspotPolygonalVisited"] = "hotspot-non-sequenced-polygonal--visited";
    HotspotStyle["HotspotIndicator"] = "hotspot-indicator";
    HotspotStyle["HotspotIndicatorVisited"] = "hotspot-indicator--visited";
    HotspotStyle["HotspotTeleportArrow"] = "hotspot-teleport-arrow";
    HotspotStyle["HotspotConfirmClick"] = "hotspot-confirm-click";
})(HotspotStyle || (HotspotStyle = {}));
